import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import Layout from "../../Common/Components/Layout/Layout";
import { useState, useEffect } from "react";
import { getDashboardLists, getPBIDashboards } from "../../Services/chat-bot-service";
import Card from "../../Common/Components/Card/Card";
import { callLogEvent, Item } from "../../Common/Util";
import style from "./WorkSpace.module.css"
import { NEW_DAILOG } from "../../Common/Constants";
import TabTitle from "../../Common/Components/TabTitle/TabTitle";
import PBIDashboard from "../../Common/Components/PBIDashboard/PBIDashboard";
import { Spinner } from "react-bootstrap";


const WorkSpace = () => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(false);
    const [showDashboard, setShowDashboard] = useState<boolean>(false);
    const [pbiList, setpbiList] = useState<any>();
    const getPBIDashboardsList = async () => {
        setLoading(true);
        // const response = await getPBIDashboards();
        const response = await getDashboardLists();
        setpbiList(response);
        setLoading(false);
    }
    useEffect(() => {
        getPBIDashboardsList();
    }, []);
    const handleSummaryClick = () => {
        console.log("Navigating to NEW_DAILOG:", NEW_DAILOG);
        navigate(NEW_DAILOG)
    }
    const handleDashboardClick = () => {
        setShowDashboard(true)
    }
    const handleResetToNewChat = () => {
        localStorage.setItem("lastChatHistory", "");
        callLogEvent("CLICKED_WORKSPACE_ASK_AI_BUTTON", "Clicked ASK AI botton");
        navigate(NEW_DAILOG)
    };

    return <>
        <div className="App">
            <TabTitle title={"Workspaces"} handleClick={handleResetToNewChat} chatTitle="Ask AI" isBackBtn={showDashboard} handleBack={() => setShowDashboard(false)} />
            {!showDashboard ? <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} className={style.cardContainer}>
                {isLoading ? <div className={"loaderWrapper"}>
                    <Spinner animation="border" variant="primary">
                        <span className="visually-hidden"></span>
                    </Spinner>
                </div>
                    :
                    pbiList && pbiList.length > 0 && pbiList!.map((page: any, pageIndex: number) => {
                        return <Grid item xs={12} sm={6} md={4} key={pageIndex}>
                            <Item><Card data={page} handleSummary={handleSummaryClick} handleDashboard={handleDashboardClick} onPage={"workspace"} /></Item>
                        </Grid>

                    })}
            </Grid> : <PBIDashboard title={"Topline"} dashboardURL={"https://app.powerbi.com/reportEmbed?reportId=e3e956ba-cf8c-403e-9078-c48e463283be&appId=9959bc79-e8b1-4ec4-8111-75a5d31e0c5f&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3"} onPage="workspace" />}
        </div>
    </>
}

export default Layout(WorkSpace);